import { render, staticRenderFns } from "./resume-profile-editor.vue?vue&type=template&id=4be9191f&"
import script from "./resume-profile-editor.vue?vue&type=script&lang=js&"
export * from "./resume-profile-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports